import { render } from "./PasswordChange.vue?vue&type=template&id=2a7ba61e&scoped=true&ts=true"
import script from "./PasswordChange.vue?vue&type=script&lang=ts"
export * from "./PasswordChange.vue?vue&type=script&lang=ts"

import "./PasswordChange.vue?vue&type=style&index=0&id=2a7ba61e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7ba61e"]])

export default __exports__